import type { AuthLogin, AuthPassword, AuthState } from "~/@types/store/auth";
import type { Usuario } from "~/@types/schemas/usuario";
import { AuthApi } from "~/api/auth";

export const useAuthStore = defineStore({
  id: 'auth-store',
  state: (): AuthState => ({
    authenticated: false,
    loading: false,
    user: null,
    token: null,
  }),

  persist: {
    storage: persistedState.cookiesWithOptions({
      maxAge: 60 * 60 * 24 * 30,
      priority: "high",
      watch: true,
    }),
  },

  getters: {
    authUser: (state) => state.user,
  },

  actions: {
    async authenticate(options: AuthLogin) {
      if (this.loading) return;

      this.loading = true;

      try {
        if (!options.login) throw new CustomWarn('Preencha o campo de login');
        if (!options.senha) throw new CustomWarn('Preencha o campo de senha');

        const { data } = await AuthApi.login(options);

        this.token = data.token;
        this.user = data.usuario;
        this.authenticated = true;

        useRouter().push('/');
      }
      catch (error) { }

      this.loading = false;
    },

    setUser(user: Usuario | null) {
      const current = JSON.stringify(this.user);  
      const newUser = JSON.stringify(user);

      if (current === newUser) return;

      this.user = user;
    },

    async changePassword(options: AuthPassword) {
      try {
        if (!options.senha) throw new CustomWarn('Preencha o campo de senha');
        if (!options.confirmacao) throw new CustomWarn('Preencha o campo de confirmação');
        if (options.senha !== options.confirmacao) throw new CustomWarn('As senhas não coincidem');

        const { data } = await AuthApi.senha(options);

        this.token = data.token;
        this.user = data.usuario;
      }
      catch (error) {
        throw new CustomError(error.message);
      }
    },

    async logout() {
      this.resetStore();
      useRouter().push('/login');
    },

    resetStore() {
      localStorage.clear();
      sessionStorage.clear();
      this.$reset();
    }
  }
});